function isRezdyEmail(email: string): boolean {
    if (email?.match(/\@(rezdy.com)$/)) {
        const tokens = email.split('@');
        const emailName = tokens[0];
        // ignore rezdy emails with +
        return emailName.indexOf('+') < 0;
    }
    return false;
}

export { isRezdyEmail };
